import React from 'react';
import moment from 'moment/moment';
import { useFormContext } from 'react-hook-form';
import { DateRangeWithPeriods } from 'components/form';

export const CreateDateRange = () => {
  const { control, setValue } = useFormContext();

  const handleSelectRange = async (range: { endDate: moment.Moment; startDate: moment.Moment }) => {
    setValue('CREATE_DATE_RANGE.to', range.endDate);
    setValue('CREATE_DATE_RANGE.from', range.startDate);
  };

  return (
    <DateRangeWithPeriods
      control={control}
      onRangeChange={handleSelectRange}
      nameTo="CREATE_DATE_RANGE.to"
      nameFrom="CREATE_DATE_RANGE.from"
    />
  );
};
